const DataActionTypes = {
    DISPLAY_DATA: "DISPLAY_DATA"
}

export default DataActionTypes;